import type { AgChartOptions } from "ag-charts-community";
import { useMemo } from "react";

import { Chart } from "@web-app/components";

import ChartWrapper from "./ChartWrapper";

interface DonutChartData {
  datasets: Array<{
    backgroundColor?: string[];
    data: number[];
  }>;
  labels: string[];
}

interface DonutChartProps {
  data: DonutChartData;
  title: string;
}

export default function DonutChart({ data, title }: DonutChartProps) {
  const chartData = useMemo(() => {
    if (!data?.labels || !data?.datasets?.[0]?.data) return [];

    return data.labels.map((label, index) => ({
      category: label,
      value: data.datasets[0].data[index] || 0,
    }));
  }, [data]);

  const chartOptions: AgChartOptions = useMemo(
    () => ({
      data: chartData,
      series: [
        {
          angleKey: "value",
          calloutLabelKey: "category",
          innerRadiusRatio: 0.6,
          sectorLabelKey: "value",
          type: "donut",
        },
      ],
    }),
    [chartData],
  );

  return (
    <ChartWrapper title={title}>
      <Chart options={chartOptions} isLoading={false} />
    </ChartWrapper>
  );
}
